import { get } from 'lodash'

export default function(fields, fileUrl, data) {
  return {
    ...fields,
    assessorId: get(data, 'assessorId'),
    activityId: get(data, 'activityId'),
    activityCategoryId: get(data, 'activityCategoryId'),
    ajEventId: get(data, 'ajEventId'),
    residentialProjectId: get(data, 'residentialProjectId'),
    fileUrl
  }
}

